import React, { useContext, useReducer } from 'react';
import { Modal } from 'antd';
import Header from './Header/Header';
import useCreateBookingHook from './CreateBooking.hook';
import { AppContext } from 'App.context';
import SelectDate from './SelectDate/SelectDate';
import {
  CreateBookingFormContext,
  createBookingFormReducer,
  formActions,
  initialFormState,
} from './CreateBookingForm.context';
import SelectRooms from './SelectRooms/SelectRooms';
import GuestDetails from './GuestDetails/GuestDetails';
import BookingSummary from './BookingSummary/BookingSummary';
import { ReactComponent as AddHeader } from 'assets/images/add-header.svg';

import './CreateBooking.css';

export default function CreateBooking({ isOpen, onCancel, onSuccess, guestMockedData }) {
  const [formState, dispatch] = useReducer(createBookingFormReducer, initialFormState);
  const { state, actions } = useCreateBookingHook({
    guestMockedData,
    formState,
    dispatch,
    onSuccess,
  });
  const {
    appActions: { translate },
  } = useContext(AppContext);
  const steps = [
    {
      icon: <AddHeader />,
      title: 'createBooking.steps.selectDate.title',
      description: 'createBooking.steps.selectDate.description',
      content: <SelectDate onNext={actions.nextStep} />,
      width: '400px',
    },
    {
      icon: <AddHeader />,
      title: 'createBooking.steps.selectRooms.title',
      description: 'createBooking.steps.selectRooms.description',
      content: <SelectRooms onNext={actions.nextStep} />,
      width: '90%',
      onBack: actions.previousStep,
    },
    {
      icon: <AddHeader />,
      title: 'createBooking.steps.guestDetails.title',
      description: 'createBooking.steps.guestDetails.description',
      content: <GuestDetails onNext={actions.nextStep} />,
      width: '90%',
      onBack: actions.previousStep,
    },
    {
      icon: <AddHeader />,
      title: 'createBooking.steps.bookingSummary.title',
      description: 'createBooking.steps.bookingSummary.description',
      content: <BookingSummary onNext={actions.finalStep} isLoading={state.isLoading} />,
      width: '90%',
      onBack: actions.previousStep,
    },
  ];
  const currentStep = steps[state.currentStep];

  return (
    <CreateBookingFormContext.Provider value={{ formState, dispatch }}>
      <Modal
        open={isOpen}
        footer={null}
        onCancel={onCancel}
        afterClose={() => {
          actions.onClose();
          dispatch({ type: formActions.RESET_FORM });
        }}
        maskClosable={false}
        className="create-booking-modal"
        width={currentStep.width}
        centered={true}
        title={
          <Header
            icon={currentStep.icon}
            title={translate(currentStep.title)}
            description={translate(currentStep.description)}
            onBack={currentStep.onBack}
          />
        }
      >
        {currentStep.content}
      </Modal>
    </CreateBookingFormContext.Provider>
  );
}
